module.exports = __webpack_public_path__ + "static/media/deleteIcon.d54952e7.svg";